/** Общие мелочи экрана «Записи»: плитка, кликабельное число, классы таблиц. */
import { Link } from "react-router";

export const card = "rounded-[var(--radius-card)] border border-border bg-bg-subtle";
export const th = "whitespace-nowrap px-3 py-1.5 text-right font-medium";
export const td = "px-3 py-1.5 text-right tabular-nums";

export const pct = (a: number, b: number) => (b ? `${Math.round((a * 100) / b)}%` : "—");

export function Num({ n, on, active }: { n: number; on: () => void; active: boolean }) {
  if (!n) return <span className="text-fg-faint">·</span>;
  return (
    <button
      type="button"
      onClick={on}
      className={`tabular-nums underline decoration-border underline-offset-2 hover:decoration-fg ${
        active ? "rounded bg-accent/15 px-1 font-medium" : ""
      }`}
      title="Показать людей"
    >
      {n}
    </button>
  );
}

/** Число-ссылка в другой раздел: звонки или чаты, которыми записали. */
export function NumLink({ n, to, title }: { n: number; to: string; title: string }) {
  if (!n) return <span className="text-fg-faint">·</span>;
  return (
    <Link to={to} title={title} className="tabular-nums text-accent-text underline decoration-accent/40 underline-offset-2 hover:decoration-accent">
      {n}
    </Link>
  );
}

export function Tile({ label, value, hint }: { label: string; value: string | number; hint?: string }) {
  return (
    <div className={`${card} flex min-w-0 flex-col gap-1 p-4`} data-annot={`плитка «${label}»`}>
      <span className="text-[12px] text-fg-muted">{label}</span>
      <span className="text-[22px] font-semibold tabular-nums tracking-[-0.02em]">{value}</span>
      {hint && <span className="text-[11.5px] text-fg-faint">{hint}</span>}
    </div>
  );
}
